var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 0C100.289 0 0 35.816 0 80V432C0 476.18 100.289 512 224 512S448 476.18 448 432V80C448 35.816 347.711 0 224 0ZM224 464C125.316 464 62.611 440.211 48 426.195V353.383C89.014 372 152.523 384 224 384S358.986 372 400 353.383V426.195C385.389 440.211 322.684 464 224 464ZM400 298.195C385.389 312.211 322.684 336 224 336S62.611 312.211 48 298.195V225.383C89.014 244 152.523 256 224 256S358.986 244 400 225.383V298.195ZM400 170.195C385.389 184.211 322.684 208 224 208S62.611 184.211 48 170.195V85.805C62.611 71.789 125.314 48 224 48S385.389 71.789 400 85.805V170.195Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.66a3f2a9d149155f0caad6782b0f4525.svg";
export { ForwardRef as ReactComponent };